"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ElementDefinition_Slicing = exports.ElementDefinition_SlicingRulesKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_ElementDefinition_Discriminator_1 = require("./RTTI_ElementDefinition_Discriminator");
var RTTI_Element_1 = require("./RTTI_Element");
var ElementDefinition_SlicingRulesKind;
(function (ElementDefinition_SlicingRulesKind) {
    ElementDefinition_SlicingRulesKind["_closed"] = "closed";
    ElementDefinition_SlicingRulesKind["_open"] = "open";
    ElementDefinition_SlicingRulesKind["_openAtEnd"] = "openAtEnd";
})(ElementDefinition_SlicingRulesKind = exports.ElementDefinition_SlicingRulesKind || (exports.ElementDefinition_SlicingRulesKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ElementDefinition_Slicing = t.recursion('IElementDefinition_Slicing', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        discriminator: t.array(RTTI_ElementDefinition_Discriminator_1.RTTI_ElementDefinition_Discriminator),
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element,
        ordered: t.boolean,
        _ordered: RTTI_Element_1.RTTI_Element,
        rules: (0, EnumType_1.createEnumType)(ElementDefinition_SlicingRulesKind, 'ElementDefinition_SlicingRulesKind'),
        _rules: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_ElementDefinition_Slicing.js.map